import TotalPriceVehicleProgressBarDrawerContainer from './TotalPriceVehicleProgressBarDrawerContainer';

export default TotalPriceVehicleProgressBarDrawerContainer;
